import cn from "classnames";

import { LoaderProps } from "./Loader.types";

import styles from "./Loader.module.scss";

const Loader = ({ className, size = 32, color = "#fff" }: LoaderProps) => {
  const borderWidth = size > 20 ? 5 : 3;

  return (
    <div
      className={cn(styles.loader, className)}
      style={{ width: size, height: size, borderColor: color, borderWidth }}
    />
  );
};

export default Loader;
